import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filetype"
})
export class FileTypePipe implements PipeTransform {
    transform(file: string): string {
        var extension = file.split(".").pop();

        switch (extension?.toLowerCase()) {
            case "jpg":
            case "gif":
            case "jpeg":
            case "png":
            case "bmp":
                return "image";
            case "mp3":
            case "wav":
                return "audio";
            case "mp4":
            case "mkv":
            case "avi":
            case "webm":
                return "video";
            default:
                return "cloud_download";
        }
    }
}
